import React from "react";
import forgetPassImg from "../../../assets/images/other_images/reset_pass_image.png";
import Styles from "./ForgetPassword.module.css";
import Form from "./Form";
function ForgetPassword(props) {
  return (
    <div className={Styles.loginPageContainer}>
      <div className={Styles.loginPageDisplay}>
        <p className={Styles.loginPageDisplay__text}>Reset your Password</p>
       
        <img src={forgetPassImg} alt="rocket" className={Styles.mainImg} />
      </div>

      <div className={Styles.loginPageForm}>
        <Form />
      </div>
    </div>
  );
}

export default ForgetPassword;
